import React from 'react';

import { ExportsContext } from 'Lib/context/exportsContext';

export interface IExportsState {
    exportInFlight: boolean;
    totalChunks: number;
    chunkCounter: number;
    RecordType: string;
    filterQuery: string;
    exportError: string;
    opts?: {
        ibnEnabled?: boolean;
        assets?: string;
    };
}

export interface IExportsContext extends IExportsState {
    setExportsContext: React.Dispatch<React.SetStateAction<IExportsState>>;
}

export const useExports = (): IExportsContext => {
    const exports = React.useContext<IExportsContext>(ExportsContext);

    return { ...exports };
};